import { makeStyles } from 'tss-react/mui';
import EDDialog from '../../../../BaseComponents/Dialog/EDDialog';
import EDBox from '../../../../BaseComponents/EDBox/EDBox';
import EDView from '../../../../BaseComponents/View/EDView';
import { AppContainer } from '../../../../Components/AppContainer/AppContainer';
import ErrorBoundary from '../../../../Components/ErrorBoundary/ErrorBoundary';
import NoSessionBackground from '../NoSessionBackground/NoSessionBackground';
import Logo from '../../../../Assets/Branding/Aveny_logo.svg';
import { NewPasswordForm } from './Components/NewPasswordForm/NewPasswordForm';
import { useLocation } from 'react-router';
import { useMutation } from '@apollo/client';
import ChangePwdMutationDoc from './Mutations/ChangePwd.gql';
import {
  ChangePwd,
  ChangePwdVariables,
} from './Mutations/_QueryTypes/ChangePwd';
import { InternalError } from '../../../../Components/InternalError/InternalError';

const useStyles = makeStyles()(theme => ({
  dialogHeaderTopArea: {
    alignItems: 'center',
  },
  dialogHeaderContent: {
    minWidth: 0,
    width: '100%',
  },
}));

interface IProps {}

export const NewPasswordPage: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes } = useStyles();
  const location = useLocation();

  const [changePwdMutation, { data, error, loading }] = useMutation<
    ChangePwd,
    ChangePwdVariables
  >(ChangePwdMutationDoc);

  const query = new URLSearchParams(location.search);
  const dbName = query.get('dbName');
  const key = query.get('key');
  const validTo = query.get('validTo');

  return (
    <ErrorBoundary name="NewPassword">
      <AppContainer>
        <EDView
          style={{
            display: 'flex',
            flex: '1 1 auto',
          }}
        >
          <NoSessionBackground hideEnvironment />
        </EDView>
      </AppContainer>
      <EDDialog
        open={!error}
        title="Ändra lösenord"
        subtitle={dbName}
        headerProps={{
          headerIcon: (
            <img
              src={Logo}
              alt="Aveny Logo"
              style={{ marginRight: '16px', height: '64px' }}
            />
          ),
          classes: {
            content: classes.dialogHeaderContent,
            topArea: classes.dialogHeaderTopArea,
          } as any,
        }}
        backdropInvisible
        noCloseIcon
        fullScreenBreakpoint={'xs'}
      >
        <EDBox sx={{ width: '300px' }}>
          <NewPasswordForm
            isChangingPassword={loading}
            errorMessage={data?.rtn?.SYSUserChangePwd?.message ?? undefined}
            result={data?.rtn?.SYSUserChangePwd?.result}
            dbName={dbName}
            newPwdKey={key}
            changePwdMutation={changePwdMutation}
            data={data}
            validTo={validTo}
          />
        </EDBox>
      </EDDialog>
      {error && (
        <InternalError
          id="changePwdMutationError"
          message={error.message}
          error={error}
        />
      )}
    </ErrorBoundary>
  );
};
